import useOverlay from "@/hooks/common/useOverlay";
import SharePopup from "@COMPONENTS/common/modal/share/Mobile";
import * as style from "@COMPONENTS/style/productlist/productlistM";
import {CompareBox} from "@FRAMEWORK/ui/mobile/layout";
import {GoodsByMenu} from "@QUERIES/prdt/goods/useGoodsByMenu";
import {useRouter} from "next/router";
import React from "react";
import LocalInfo from "./LocalInfo";
import LocalPrice from "./LocalPrice";
import LocalThumbnail from "./LocalThumbnail";

interface Props {
	product: GoodsByMenu;
	selectedProduct: string[];
	selectToCompare: (e: React.ChangeEvent<HTMLInputElement>) => void;
	handleDeparturePopup: (goodsCd: string) => void;
}

const LocalGoods = ({product, selectedProduct, selectToCompare, handleDeparturePopup}: Props) => {
	// 비교 상품 선택 확인
	const isChecked = selectedProduct.includes(product.goodsCd);

	// 공유하기
	const [open] = useOverlay();
	const router = useRouter();
	const dspSid = `${router.query?.dspSid?.slice(0, -2)}00` as string;
	const menu = router.query?.menu as string;

	const handleShare = (goodsCd: string) => {
		open(prop => <SharePopup {...prop} parameter={`menu=${menu}&dspSid=${dspSid}&goodsCd=${goodsCd}`} />);
	};

	return (
		<style.ProductListItem>
			{/* 썸네일 */}
			<LocalThumbnail
				selectedProduct={selectedProduct}
				selectToCompare={selectToCompare}
				product={product}
				handleShare={handleShare}
			/>
			{/* 상품정보 */}
			<LocalInfo product={product} />
			{/* 가격정보 */}
			<LocalPrice product={product} />
			{/* 비교하기 */}
			<CompareBox
				state={isChecked}
				onClick={e => {
					e.stopPropagation();
					selectToCompare({...e, target: {value: product.goodsCd, checked: false}});
				}}
			/>
			<style.ProductListItemData
				onClick={e => {
					e.preventDefault();
					handleDeparturePopup(product.goodsCd);
				}}
			/>
		</style.ProductListItem>
	);
};

export default LocalGoods;
